/* 刺繍・左右補強の「しない」表示から、位置語（上・下・左・右）を消した。位置は画像で示す 2026.10.26 */
/* 糸・刺繍の「しない」行：並びを「しない：色名［画像］」にした（変更の後に画像が来ると、しないが通りづらいため）。画像の複製を文字の間に入れる部品を、先頭に追加 2026.10.25 */
/* 「しない：色名［画像］」の並びにする部品（糸・刺繍の「しない」行で共通）ここから 2026.10.25 */
/* アプリの画像（thumb／chip）は動かさず、隠す。同じ絵の複製を、文字「しない：色名」のすぐ後ろに入れる（アプリが文字を書き直しても壊れないため）。画像を最後に変更 2026.10.25 */
(function () {
  'use strict';

  if (window.japlishAfterImage) return;

  var HOLDER_CLASS = 'japlish-after-img';
  var KEY_ATTR = 'data-japlish-after';

  /* 複製した絵のIDが元と重ならないよう、IDに -after を付ける */
  function suffixIds(html) {
    var ids = [];

    html.replace(/\sid="([^"]+)"/g, function (match, id) {
      ids.push(id);
      return match;
    });

    ids.forEach(function (id) {
      var esc = id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      html = html
        .replace(new RegExp('id="' + esc + '"', 'g'), 'id="' + id + '-after"')
        .replace(new RegExp('url\\(#' + esc + '\\)', 'g'), 'url(#' + id + '-after)')
        .replace(new RegExp('href="#' + esc + '"', 'g'), 'href="#' + id + '-after"');
    });

    return html;
  }

  function sourceKey(thumb) {
    return thumb.tagName === 'IMG'
      ? 'img:' + (thumb.getAttribute('src') || '')
      : 'svg:' + thumb.innerHTML;
  }

  function hide(element) {
    if (element.style.getPropertyValue('display') !== 'none') {
      element.style.setProperty('display', 'none', 'important');
    }
  }

  function show(element) {
    if (element && element.style.getPropertyValue('display') === 'none') {
      element.style.removeProperty('display');
    }
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  /* 画像を文字の最後へ回す。text は「しない：色名」の形 */
  function place(thumb, label, text, size) {
    if (!label) return;

    /* 「しない：」で始まらない文字（例：色名（糸と同じ））は、並べ替えない */
    if (!thumb || text.indexOf('しない：') !== 0) {
      restore(thumb, label);
      setText(label, text);
      return;
    }

    var key = text + '|' + size + '|' + sourceKey(thumb);
    var holder = label.querySelector(':scope > .' + HOLDER_CLASS);

    if (!holder || label.getAttribute(KEY_ATTR) !== key) {
      /* 元の絵の大きさを覚える（隠した後は測れないため） */
      var rect = thumb.getBoundingClientRect();
      var width = Math.round(rect.width) || Number(label.getAttribute('data-japlish-after-w')) || size;
      var height = Math.round(rect.height) || Number(label.getAttribute('data-japlish-after-h')) || size;

      label.setAttribute('data-japlish-after-w', String(width));
      label.setAttribute('data-japlish-after-h', String(height));

      holder = document.createElement('span');
      holder.className = HOLDER_CLASS;
      holder.setAttribute('aria-hidden', 'true');
      holder.style.cssText =
        'display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;' +
        'margin:0 0 0 6px;width:' + width + 'px;height:' + height + 'px;';

      if (thumb.tagName === 'IMG') {
        var img = document.createElement('img');
        img.setAttribute('src', thumb.getAttribute('src') || '');
        img.setAttribute('alt', '');
        img.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain;';
        holder.appendChild(img);
      } else {
        holder.innerHTML = suffixIds(thumb.innerHTML);
      }

      label.textContent = '';
      label.appendChild(document.createTextNode(text));
      label.appendChild(holder);
      label.setAttribute(KEY_ATTR, key);
    }

    label.style.setProperty('display', 'flex', 'important');
    label.style.setProperty('align-items', 'center', 'important');
    label.style.setProperty('white-space', 'nowrap', 'important');
    label.style.setProperty('min-width', '0', 'important');
    label.style.setProperty('overflow', 'hidden', 'important');

    hide(thumb);
  }

  /* 元の並びに戻す（アプリの画像を出し、複製を外す） */
  function restore(thumb, label) {
    show(thumb);

    if (!label) return;

    var holder = label.querySelector(':scope > .' + HOLDER_CLASS);

    if (holder) {
      holder.remove();
      label.textContent = label.textContent;
    }

    if (label.hasAttribute(KEY_ATTR)) {
      label.removeAttribute(KEY_ATTR);
      label.style.removeProperty('display');
      label.style.removeProperty('align-items');
      label.style.removeProperty('white-space');
      label.style.removeProperty('min-width');
      label.style.removeProperty('overflow');
    }
  }

  window.japlishAfterImage = { place: place, restore: restore };
})();
/* 「しない：［画像］色名」の並びにする部品ここまで */

/* 補強糸（2色）「変更しない／変更する」行の色見本ここから */
/* 2026.10.26：選択肢「補強糸を無くす」を追加（アプリ側で画像を設定）。しない・する以外を選んだ時に、閉じた欄が「しない：…」になる不具合を直した */
/* アプリの選択肢の値が「しない」「する」でも、「変更しない」「変更する」でも動く 2026.10.25 */
/* 表示名を「色名：変更無し」から「しない：色名」へ（項目名が「…の変更」なので「しない」で足りる。狭い欄で見切れにくい）2026.10.25 */
/* 対象：項目名「補強糸の変更」の画像付きプルダウン。どの製品に出るかはタグ（emb-bottom-top-under）で割り当て、標準色は商品ハンドルで引く。クラスは使わない 2026.10.23 */
/* 「変更しない」行：その製品・サイズの標準色を、2本線のSVGで描く。「変更する」行：丸にプラスの記号を描く 2026.10.23 */
/* 白の縁を濃くした（全ブロック共通）：#BDBDBD → #999999、四角の縁は2→3、イカリの縁は＋2.4→＋4。四角は縁が四方を囲む 2026.10.24 */
/* 標準色は、商品ハンドル＋選択中のサイズ（S／M／スクエア等）で引く。'*' はサイズ共通 2026.10.23 */
(function () {
  'use strict';

  /* 項目名で探す。ハンドルが標準色の表にある製品だけ処理するので、1色の補強などには影響しない 2026.10.23 */
  var FIELD_LABEL = '補強糸の変更';

  /* 糸の色（twotone-ito.js の THREAD_HEX と同じ値） 2026.10.23 */
  var THREAD_HEX = {
    '金': '#F5DC38',
    '赤': '#DE0913',
    '白': '#FCF9F2',
    '緑': '#029656',
    '黒': '#2E2D2D',
    'カーキ': '#706939',
    '茶': '#67361D',
    '黄': '#FCF00A',
    '水色': '#38A0FF',
    '紺': '#1A2D56',
    '紫': '#7F16A6',
    'ブルーグレー': '#718AAB'
  };

  /* 2本線専用の色。糸の紺は暗く見えるため、ここだけ青寄りにする 2026.10.23 */
  var TWO_LINE_HEX = {
    '紺': '#24408E'
  };

  /* 標準色の表：商品ハンドル → サイズ → [上の色, 下の色] 2026.10.23 */
  var STANDARD = {
    'jb-8': {
      'S': ['白', '赤'],
      'M': ['赤', '緑'],
      'スクエア': ['水色', '黄']
    },
    /* jb-6：上＝白、下＝赤（縦2本から補強2色に変更）2026.10.24 */
    'jb-6': {
      '*': ['白', '赤']
    },
    /* jb-14：上＝紺、下＝赤（上下の順を修正）2026.10.24 */
    'jb-14': {
      '*': ['紺', '赤']
    }
  };

  /* プレビュー用に表を公開（上下2色：[上, 下]）2026.10.26 */
  window.japlishEmbTables = window.japlishEmbTables || {};
  window.japlishEmbTables.reinTopBottom = STANDARD;

  var queued = false;
  var observer = null;
  var attached = false;

  function lineHex(colorName) {
    return TWO_LINE_HEX[colorName] || THREAD_HEX[colorName] || '#999999';
  }

  /* 商品ハンドルをURLから読む 2026.10.23 */
  function getHandle() {
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';

    var handle = match[1];

    try {
      handle = decodeURIComponent(match[1]);
    } catch (error) {
      handle = match[1];
    }

    /* テスト製品（ハンドルの頭が test-）は、本番と同じ表で引く。全角のハンドル（ｇ-39）も半角にそろえて引く 2026.10.24 */
    return handle.normalize('NFKC').replace(/^test-/, '');
  }

  /* 選択中のサイズ名を読む。選択肢の値は「S:￥27,500」の形なので、「：」より前だけを使う 2026.10.23 */
  function getStandard() {
    var table = STANDARD[getHandle()];
    if (!table) return null;

    var selects = document.querySelectorAll('select[data-variant-input]');

    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.selectedIndex < 0) continue;

      var text = select.options[select.selectedIndex].textContent.trim();
      var match = text.match(/^([^:：]+)[:：]/);
      var size = match ? match[1].trim() : text;

      if (table[size]) return table[size];
    }

    return table['*'] || null;
  }

  /* 2本線のSVG：細い2本を、間を空けて縦に重ねる。枠は白だけ薄いグレー。光沢なし 2026.10.23 */
  function twoLineSvg(topColor, underColor) {
    function cord(y, colorName) {
      var edge = colorName === '白' ? ' stroke="#999999" stroke-width="3"' : '';

      return '<rect x="5" y="' + y + '" width="90" height="16" rx="8" fill="' +
        lineHex(colorName) + '"' + edge + '/>';
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false">' +
      cord(29, topColor) + cord(55, underColor) + '</svg>';
  }

  /* 丸の中に記号：kind が 'minus' なら「ー」、'plus' なら「＋」 2026.10.23 */
  function circleSvg(kind) {
    var lines = '<line x1="30" y1="50" x2="70" y2="50"/>';

    if (kind === 'plus') {
      lines += '<line x1="50" y1="30" x2="50" y2="70"/>';
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false" ' +
      'fill="none" stroke="#444" stroke-width="7" stroke-linecap="round">' +
      '<circle cx="50" cy="50" r="40"/>' + lines + '</svg>';
  }

  /* 色見本の枠：書き換えは「内容が変わった時だけ」行う（点滅・無限ループ防止） 2026.10.23 */
  function setChip(chip, svg, size) {
    if (!chip) return;

    var key = size + '|' + svg;

    if (chip.dataset.japlishReinforce !== key) {
      chip.innerHTML = svg;
      chip.dataset.japlishReinforce = key;
    }

    chip.style.setProperty('display', 'inline-flex', 'important');
    chip.style.setProperty('align-items', 'center', 'important');
    chip.style.setProperty('justify-content', 'center', 'important');
    chip.style.setProperty('width', size + 'px', 'important');
    chip.style.setProperty('height', size + 'px', 'important');
    chip.style.setProperty('min-width', size + 'px', 'important');
    chip.style.setProperty('flex', '0 0 ' + size + 'px', 'important');
    chip.style.setProperty('background-color', 'transparent', 'important');
    chip.style.setProperty('background-image', 'none', 'important');
    chip.style.setProperty('border', '0', 'important');
    chip.style.setProperty('border-radius', '0', 'important');
    chip.style.setProperty('overflow', 'visible', 'important');
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function setAttr(element, name, value) {
    if (element && element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  }

  /* 標準の行の名前：色名を詰めて短くする。水色は「水」と書く。文字の先頭は「しない：」（2026.10.25に「色名：変更無し」から変更）2026.10.24 */
  function shortName(color) {
    return color === '水色' ? '水' : color;
  }

  /* 「変更しない」行に入れる色見本と文字 2026.10.23 */
  function noChangeContent(standard) {
    return {
      svg: twoLineSvg(standard[0], standard[1]),
      label: 'しない：' + shortName(standard[0]) + shortName(standard[1])
    };
  }

  function updateField(field) {
    /* 標準色の表にない製品は、何も変えない 2026.10.23 */
    var standard = getStandard();
    if (!standard) return;

    var noChange = noChangeContent(standard);
    var plus = circleSvg('plus');

    /* 候補欄の各行 */
    field.querySelectorAll('.spb-imagedropdown-option').forEach(function (option) {
      var value = option.getAttribute('data-value');
      var chip = option.querySelector('.spb-imagedropdown-chip');
      var label = option.querySelector('.spb-imagedropdown-optionlabel');

      if (/^(変更)?しない$/.test(value || '')) {
        setChip(chip, noChange.svg, 34);
        window.japlishAfterImage.place(chip, label, noChange.label, 34); /* しない：色名［画像］ 2026.10.25 */
        setAttr(option, 'aria-label', noChange.label);
      } else if (/^(変更)?する$/.test(value || '')) {
        setChip(chip, plus, 34);
      }
    });

    /* 閉じた選択欄 */
    var selectedOption = field.querySelector(
      '.spb-imagedropdown-option[aria-selected="true"]'
    );

    var selected = field.querySelector('.spb-imagedropdown-selected');

    if (selected) {
      var selectedChip = selected.querySelector('.spb-imagedropdown-chip');
      var selectedLabel = selected.querySelector('.spb-imagedropdown-selected-label');
      var selectedValue = selectedOption
        ? selectedOption.getAttribute('data-value')
        : '変更しない';

      if (/^(変更)?する$/.test(selectedValue || '')) {
        window.japlishAfterImage.restore(selectedChip, selectedLabel); /* 並びを元に戻す 2026.10.25 */
        setChip(selectedChip, plus, 28);
        setText(selectedLabel, selectedValue);
      } else if (/^(変更)?しない$/.test(selectedValue || '')) {
        setChip(selectedChip, noChange.svg, 28);
        window.japlishAfterImage.place(selectedChip, selectedLabel, noChange.label, 28); /* しない：色名［画像］ 2026.10.25 */
      } else {
        /* 「しない」「する」以外（補強糸を無くす 等）：アプリの表示（画像・文字）にまかせる。これまでは全部「しない」と見ていた 2026.10.26 */
        window.japlishAfterImage.restore(selectedChip, selectedLabel);
        clearChip(selectedChip);
      }
    }
  }

  /* こちらで描いた絵を消して、アプリの表示を邪魔しない状態に戻す 2026.10.26 */
  function clearChip(chip) {
    if (!chip || !chip.dataset.japlishReinforce) return;

    chip.innerHTML = '';
    delete chip.dataset.japlishReinforce;

    ['display', 'align-items', 'justify-content', 'width', 'height', 'min-width', 'flex',
      'background-color', 'background-image', 'border', 'border-radius', 'overflow'].forEach(function (name) {
      chip.style.removeProperty(name);
    });
  }

  /* 項目名が「補強糸の変更」の項目を探す 2026.10.23 */
  function findFields() {
    var fields = [];

    document.querySelectorAll('#infiniteoptions-container label').forEach(function (label) {
      if (label.textContent.trim() !== FIELD_LABEL) return;

      var field = label.closest('[class*="spb-io-field-"]');

      if (field && fields.indexOf(field) === -1) {
        fields.push(field);
      }
    });

    return fields;
  }

  function updateAll() {
    findFields().forEach(updateField);
  }

  function scheduleUpdate() {
    if (queued) return;
    queued = true;

    window.setTimeout(function () {
      queued = false;
      updateAll();
    }, 60);
  }

  /* アプリの描画が遅れても拾えるよう、項目の入れ物が現れたら監視を始める 2026.10.23 */
  function attach() {
    if (attached) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    observer = new MutationObserver(scheduleUpdate);

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });

    attached = true;
    updateAll();
    return true;
  }

  /* サイズ（バリエーション）の切り替えでも描き直す 2026.10.23 */
  document.addEventListener('change', scheduleUpdate);

  document.addEventListener('click', function (event) {
    if (event.target.closest('#infiniteoptions-container, .variant-wrapper')) {
      scheduleUpdate();
    }
  });

  function start() {
    if (attach()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (attach() || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* 補強糸（2色）「変更しない／変更する」行の色見本ここまで */

/* 補強糸（1色）「変更しない」行を、標準色の画像と文字に置き換えるここから */
/* 対象：項目名「補強糸の変更」の画像付きプルダウン（2色・左右と同じ項目名）。どの製品に出るかはタグ（emb-reinforce）で割り当て、標準色は商品ハンドルで引く 2026.10.24 */
/* 画像は、同じプルダウンの標準色の行から読んで、「変更しない」の行にコピーする（画像のアドレスは書かない）2026.10.23 */
/* g-65 は「糸と同じ」：ミシン糸のプルダウンで今選ばれている色に連動する 2026.10.23 */
(function () {
  'use strict';

  var FIELD_LABEL = '補強糸の変更';
  var FOLLOW_THREAD = '@糸と同じ';

  var THREAD_FIELD_SELECTOR =
    '#infiniteoptions-container .thread-basic, ' +
    '#infiniteoptions-container .thread-white, ' +
    '#infiniteoptions-container .thread-special';

  /* 糸の色の名前。「ブルーグレー」など長い名前を先に調べる 2026.10.23 */
  var COLOR_NAMES = [
    'ブルーグレー', 'カーキ', '水色', '金', '赤', '白', '緑', '黒', '茶', '黄', '紺', '紫'
  ];

  /* 標準色の表：商品ハンドル → サイズ → 色の名前。'*' は共通。FOLLOW_THREAD は糸と同じ 2026.10.24 */
  var STANDARD = {
    'ac-2': { 'S': '赤', 'M': '紺' },
    'ac-13': { '*': '黄' },
    'ac-14': { '*': '黄' },
    'g-2': { '*': '黄' },
    'g-5': { '*': '赤' },
    'g-13': { '*': '赤' }, /* 金属ボタンを刺繍に変更できる製品。補強糸は赤（確認済み）2026.10.26 */
    'g-21': { '*': '白' },
    'g-22': { '*': '赤' },
    'g-65': { '*': FOLLOW_THREAD },
    'st-3': { '*': '水色' }
  };

  /* プレビュー用に表を公開（1色：四角・横線・縦線）2026.10.26 */
  window.japlishEmbTables = window.japlishEmbTables || {};
  window.japlishEmbTables.rein1 = STANDARD;

  var queued = false;
  var observer = null;
  var attached = false;

  /* 商品ハンドルをURLから読む 2026.10.23 */
  function getHandle() {
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';

    var handle = match[1];

    try {
      handle = decodeURIComponent(match[1]);
    } catch (error) {
      handle = match[1];
    }

    /* テスト製品（ハンドルの頭が test-）は、本番と同じ表で引く。全角のハンドル（ｇ-39）も半角にそろえて引く 2026.10.24 */
    return handle.normalize('NFKC').replace(/^test-/, '');
  }

  /* 選択中のサイズ名で表を引く。選択肢の値は「S:￥27,500」の形なので、「：」より前だけを使う 2026.10.24 */
  function lookup(table) {
    var selects = document.querySelectorAll('select[data-variant-input]');

    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.selectedIndex < 0) continue;

      var text = select.options[select.selectedIndex].textContent.trim();
      var match = text.match(/^([^:：]+)[:：]/);
      var size = match ? match[1].trim() : text;

      if (table[size]) return table[size];
    }

    return table['*'] || '';
  }

  /* ミシン糸のプルダウンで、今選ばれている糸の色を読む。「白（標準）」「赤」など 2026.10.23 */
  function readThreadColor() {
    /* 糸の欄は、クラスではなく部品（twotone-ito.js）で探す。部品が無い時だけ従来のクラス 2026.10.26 */
    var fields = window.japlishThread ? window.japlishThread.fields() : document.querySelectorAll(THREAD_FIELD_SELECTOR);

    for (var i = 0; i < fields.length; i++) {
      var label = fields[i].querySelector('.spb-imagedropdown-selected-label');
      if (!label) continue;

      var text = label.textContent || '';

      for (var j = 0; j < COLOR_NAMES.length; j++) {
        if (text.indexOf(COLOR_NAMES[j]) !== -1) return COLOR_NAMES[j];
      }
    }

    return '';
  }

  /* この製品の標準色。{ color, word } を返す。決まらなければ null（何も変えない）2026.10.23 */
  function resolveStandard() {
    var table = STANDARD[getHandle()];
    if (!table) return null;

    var value = lookup(table);
    if (!value) return null;

    if (value === FOLLOW_THREAD) {
      var threadColor = readThreadColor();
      return threadColor ? { color: threadColor, word: '糸と同じ' } : null;
    }

    return { color: value, word: '標準' };
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function setAttr(element, name, value) {
    if (element && element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  }

  /* 親の中に、画像を1つ置く。空の枠（chip）は隠す。変わった時だけ書き換える 2026.10.23 */
  function putImage(parent, src, alt) {
    var img = parent.querySelector(':scope > img.japlish-reinforce-image');

    if (!img) {
      img = document.createElement('img');
      img.className = 'spb-imagedropdown-thumb japlish-reinforce-image';
      parent.insertBefore(img, parent.firstChild);
    }

    setAttr(img, 'src', src);
    setAttr(img, 'alt', alt);

    var chip = parent.querySelector(':scope > .spb-imagedropdown-chip');

    if (chip && chip.style.getPropertyValue('display') !== 'none') {
      chip.style.setProperty('display', 'none', 'important');
    }
  }

  /* 置いた画像を外し、空の枠を元に戻す 2026.10.23 */
  function removeImage(parent) {
    var img = parent.querySelector(':scope > img.japlish-reinforce-image');
    if (img) img.remove();

    var chip = parent.querySelector(':scope > .spb-imagedropdown-chip');

    if (chip && chip.style.getPropertyValue('display') === 'none') {
      chip.style.removeProperty('display');
    }
  }

  /* 標準の行の名前：色名を短くする。水色は「水」と書く（画像を探す時は元の色名を使う）2026.10.24 */
  function shortName(color) {
    return color === '水色' ? '水' : color;
  }

  function updateField(field) {
    var standard = resolveStandard();
    if (!standard) return;

    /* 標準色の行の画像のアドレスを読む */
    var source = field.querySelector(
      '.spb-imagedropdown-option[data-value="' + standard.color +
      '"] img.spb-imagedropdown-thumb:not(.japlish-reinforce-image)'
    );

    var src = source ? source.getAttribute('src') : '';
    if (!src) return;

    var labelText = standard.word === '標準'
      ? 'しない：' + shortName(standard.color)
      : shortName(standard.color) + '（' + standard.word + '）';

    /* 候補欄の「変更しない」行 */
    var option = field.querySelector('.spb-imagedropdown-option[data-value="変更しない"], .spb-imagedropdown-option[data-value="しない"]');

    if (option) {
      putImage(option, src, labelText);
      window.japlishAfterImage.place(
        option.querySelector(':scope > img.japlish-reinforce-image'),
        option.querySelector('.spb-imagedropdown-optionlabel'),
        labelText, 34
      ); /* しない：色名［画像］ 2026.10.25 */
      setAttr(option, 'aria-label', labelText);
    }

    /* 閉じた選択欄：「変更しない」を選んでいる時だけ置き換える */
    var selectedOption = field.querySelector('.spb-imagedropdown-option[aria-selected="true"]');
    var selected = field.querySelector('.spb-imagedropdown-selected');

    if (!selected) return;

    var isNoChange = !selectedOption ||
      /^(変更)?しない$/.test(selectedOption.getAttribute('data-value') || '');

    if (isNoChange) {
      putImage(selected, src, labelText);
      window.japlishAfterImage.place(
        selected.querySelector(':scope > img.japlish-reinforce-image'),
        selected.querySelector('.spb-imagedropdown-selected-label'),
        labelText, 28
      ); /* しない：色名［画像］ 2026.10.25 */
    } else {
      removeImage(selected);
      window.japlishAfterImage.restore(null, selected.querySelector('.spb-imagedropdown-selected-label'));
    }
  }

  /* 項目名が「補強糸の変更（1色用）」の項目を探す 2026.10.23 */
  function findFields() {
    var fields = [];

    document.querySelectorAll('#infiniteoptions-container label').forEach(function (label) {
      if (label.textContent.trim() !== FIELD_LABEL) return;

      var field = label.closest('[class*="spb-io-field-"]');

      if (field && fields.indexOf(field) === -1) {
        fields.push(field);
      }
    });

    return fields;
  }

  function updateAll() {
    findFields().forEach(updateField);
  }

  function scheduleUpdate() {
    if (queued) return;
    queued = true;

    window.setTimeout(function () {
      queued = false;
      updateAll();
    }, 60);
  }

  /* アプリの描画が遅れても拾えるよう、項目の入れ物が現れたら監視を始める 2026.10.23 */
  function attach() {
    if (attached) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    observer = new MutationObserver(scheduleUpdate);

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });

    attached = true;
    updateAll();
    return true;
  }

  /* サイズや糸の切り替えでも描き直す 2026.10.23 */
  document.addEventListener('change', scheduleUpdate);

  document.addEventListener('click', function (event) {
    if (event.target.closest('#infiniteoptions-container, .variant-wrapper')) {
      scheduleUpdate();
    }
  });

  function start() {
    if (attach()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (attach() || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* 補強糸（1色）「変更しない」行を、標準色の画像と文字に置き換えるここまで */


/* フタ裏の刺繍（emb-flap-h3）「変更しない」行の色見本ここから */
/* 対象：項目名「フタ裏の刺繍」の画像付きプルダウン。g-7 だけに付くセット。「変更しない」行に、縦線3本（左から緑・白・赤）を描く 2026.10.24 */
(function () {
  'use strict';

  var FIELD_LABEL = 'フタ裏の刺繍';

  /* 糸の色（twotone-ito.js の THREAD_HEX と同じ値） 2026.10.24 */
  var THREAD_HEX = {
    '金': '#F5DC38',
    '赤': '#DE0913',
    '白': '#FCF9F2',
    '緑': '#029656',
    '黒': '#2E2D2D',
    'カーキ': '#706939',
    '茶': '#67361D',
    '黄': '#FCF00A',
    '水色': '#38A0FF',
    '紺': '#24408E',
    '紫': '#7F16A6',
    'ブルーグレー': '#718AAB'
  };

  /* 標準色の表：商品ハンドル → [左, 中, 右] 2026.10.24 */
  var STANDARD = {
    'g-7': ['緑', '白', '赤']
  };

  var queued = false;
  var observer = null;
  var attached = false;

  function getHandle() {
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';

    var handle = match[1];

    try {
      handle = decodeURIComponent(match[1]);
    } catch (error) {
      handle = match[1];
    }

    /* テスト製品（ハンドルの頭が test-）は、本番と同じ表で引く。全角のハンドル（ｇ-39）も半角にそろえて引く 2026.10.24 */
    return handle.normalize('NFKC').replace(/^test-/, '');
  }

  /* 縦線3本のSVG：左から順に並べる。枠は白だけ薄いグレー 2026.10.24 */
  function threeLineSvg(colors) {
    function bar(x, colorName) {
      var edge = colorName === '白' ? ' stroke="#999999" stroke-width="3"' : '';

      return '<rect x="' + x + '" y="12" width="16" height="76" rx="8" fill="' +
        (THREAD_HEX[colorName] || '#999999') + '"' + edge + '/>';
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false">' +
      bar(16, colors[0]) + bar(42, colors[1]) + bar(68, colors[2]) + '</svg>';
  }

  /* 色見本の枠：書き換えは「内容が変わった時だけ」行う（点滅・無限ループ防止） 2026.10.24 */
  function setChip(chip, svg, size) {
    if (!chip) return;

    var key = size + '|' + svg;

    if (chip.dataset.japlishFlap !== key) {
      chip.innerHTML = svg;
      chip.dataset.japlishFlap = key;
    }

    chip.style.setProperty('display', 'inline-flex', 'important');
    chip.style.setProperty('align-items', 'center', 'important');
    chip.style.setProperty('justify-content', 'center', 'important');
    chip.style.setProperty('width', size + 'px', 'important');
    chip.style.setProperty('height', size + 'px', 'important');
    chip.style.setProperty('min-width', size + 'px', 'important');
    chip.style.setProperty('flex', '0 0 ' + size + 'px', 'important');
    chip.style.setProperty('background-color', 'transparent', 'important');
    chip.style.setProperty('background-image', 'none', 'important');
    chip.style.setProperty('border', '0', 'important');
    chip.style.setProperty('border-radius', '0', 'important');
    chip.style.setProperty('overflow', 'visible', 'important');
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function setAttr(element, name, value) {
    if (element && element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  }

  /* 標準の行の名前：色名を詰めて短くする。水色は「水」と書く。文字の先頭は「しない：」（2026.10.25に「色名：変更無し」から変更）2026.10.24 */
  function shortName(color) {
    return color === '水色' ? '水' : color;
  }

  function updateField(field) {
    var colors = STANDARD[getHandle()];
    if (!colors) return;

    var svg = threeLineSvg(colors);
    var label = 'しない：' + colors.map(shortName).join('');

    /* 候補欄の「変更しない」行 */
    var option = field.querySelector('.spb-imagedropdown-option[data-value="変更しない"], .spb-imagedropdown-option[data-value="しない"]');

    if (option) {
      setChip(option.querySelector('.spb-imagedropdown-chip'), svg, 34);
      window.japlishAfterImage.place(option.querySelector('.spb-imagedropdown-chip'), option.querySelector('.spb-imagedropdown-optionlabel'), label, 34); /* しない：色名［画像］ 2026.10.25 */
      setAttr(option, 'aria-label', label);
    }

    /* 閉じた選択欄：「変更しない」を選んでいる時だけ置き換える */
    var selectedOption = field.querySelector('.spb-imagedropdown-option[aria-selected="true"]');
    var selected = field.querySelector('.spb-imagedropdown-selected');

    if (!selected) return;

    var isNoChange = !selectedOption ||
      /^(変更)?しない$/.test(selectedOption.getAttribute('data-value') || '');

    if (isNoChange) {
      setChip(selected.querySelector('.spb-imagedropdown-chip'), svg, 28);
      window.japlishAfterImage.place(selected.querySelector('.spb-imagedropdown-chip'), selected.querySelector('.spb-imagedropdown-selected-label'), label, 28); /* しない：色名［画像］ 2026.10.25 */
    } else {
      window.japlishAfterImage.restore(selected.querySelector('.spb-imagedropdown-chip'), selected.querySelector('.spb-imagedropdown-selected-label')); /* しない以外は元の並び 2026.10.25 */
    }
  }

  /* 項目名が「フタ裏の刺繍」の項目を探す 2026.10.24 */
  function findFields() {
    var fields = [];

    document.querySelectorAll('#infiniteoptions-container label').forEach(function (label) {
      if (label.textContent.trim() !== FIELD_LABEL) return;

      var field = label.closest('[class*="spb-io-field-"]');

      if (field && fields.indexOf(field) === -1) {
        fields.push(field);
      }
    });

    return fields;
  }

  function updateAll() {
    findFields().forEach(updateField);
  }

  function scheduleUpdate() {
    if (queued) return;
    queued = true;

    window.setTimeout(function () {
      queued = false;
      updateAll();
    }, 60);
  }

  function attach() {
    if (attached) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    observer = new MutationObserver(scheduleUpdate);

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });

    attached = true;
    updateAll();
    return true;
  }

  document.addEventListener('change', scheduleUpdate);

  document.addEventListener('click', function (event) {
    if (event.target.closest('#infiniteoptions-container')) {
      scheduleUpdate();
    }
  });

  function start() {
    if (attach()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (attach() || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* フタ裏の刺繍（emb-flap-h3）「変更しない」行の色見本ここまで */


/* 刺繍の変更（イカリ・三本線・二本線）「変更しない」行の色見本ここから */
/* 対象：項目名「刺繍の変更」の画像付きプルダウン。どの製品に出るかはタグ（emb-anchor）で割り当て、標準色は商品ハンドルで引く 2026.10.24 */
/* イカリ4タイプ：3色（〇／横棒＋縦棒／V）、上下2色（上＝〇＋横棒、下＝縦棒＋V）、単色（革色で変わる）、左右配色（中央で左右に分ける）。ほかに、横線（上から順）と縦線（左から順）の2〜3本 2026.10.24 */
/* 〇は45度の四角。〇と横棒は細い1本糸、縦棒とVは太い2本糸。パーツは隣り合い、重ならない 2026.10.24 */
(function () {
  'use strict';

  var FIELD_LABEL = '刺繍の変更';

  /* 糸の色（紺はイカリの絵では青寄りの #24408E） 2026.10.24 */
  var THREAD_HEX = {
    '金': '#F5DC38',
    '赤': '#DE0913',
    '白': '#FCF9F2',
    '緑': '#029656',
    '黒': '#2E2D2D',
    'カーキ': '#706939',
    '茶': '#67361D',
    '黄': '#FCF00A',
    '水色': '#38A0FF',
    '紺': '#24408E',
    '紫': '#7F16A6',
    'ブルーグレー': '#718AAB'
  };

  /* 革色ごとの標準色（ac-1・ac-3・ac-8・st-16：全部1色）2026.10.24 */
  var LEATHER_STANDARD = {
    'キャメル': '水色',
    'ブラック': '水色',
    'レッド': '緑',
    'グレー': '緑',
    'チョコ': '赤',
    'グリーン': '赤'
  };

  /* 標準色の表：商品ハンドル → 種類別の指定 2026.10.24
     ['〇', '横棒＋縦棒', 'V']  … 3色
     { top: '〇＋横棒', bottom: '縦棒＋V' } … 上下2色
     { lr: ['左', '右'] } … 左右配色
     { leather: true } … 革色で変わる単色
     { h: ['上','中','下'] } … 横線（2本または3本、上から順）
     { v: ['左','中','右'] } … 縦線（2本または3本、左から順）
     { frame: { top, left, bottom } } … 右が開いた四角（st-3）
     PDFと実物で確認済み（2026.10.24）*/
  var STANDARD = {
    'g-67': ['紺', '黄', '赤'],
    'g-69': ['赤', '白', '緑'],
    'ac-52': ['赤', '黄', '黒'],
    'ac-53': ['水色', '黄', '水色'],
    'ac-54': ['赤', '白', '紺'], /* 白白紺 → 赤白紺に変更 2026.10.26 */
    'jb-81': ['赤', '白', '黒'],
    'sb-29': ['赤', '白', '緑'],
    'sb-15': ['紺', '白', '赤'], /* 上から 〇＝紺・横棒＋縦棒＝白・V＝赤（test-sb-15 も同じ表で引く）2026.10.26 */
    'lm-89': ['赤', '白', '緑'],
    'jb-43-s': ['赤', '白', '赤'],
    'g-22': ['紺', '赤', '紺'], /* L字長財布：引き手のイカリ。〇＝紺・横棒＋縦棒＝赤・V＝紺 2026.10.26 */
    /* ここから：PDFの表から足した製品（イカリ3色）。〇＝上・横棒＋縦棒＝中・V＝下。PDFの色を読み取ったもの。実物での確認はこれから 2026.10.26 */
    'g-2': ['水色', '黄', '水色'],
    'g-4': ['白', '紺', '赤'],
    'g-5': ['白', '赤', '白'],
    'g-7': ['黄', '黄', '黄'],
    'g-15-45': ['赤', '黄', '赤'],
    'g-21': ['赤', '白', '赤'],
    'g-24': ['水色', '黒', '白'],
    'g-31': ['赤', '黒', '赤'],
    'g-53': ['赤', '白', '赤'],
    'g-54': ['紺', '黄', '赤'],
    'g-56': ['赤', '黄', '赤'],
    'g-60': ['緑', '赤', '緑'],
    'g-61': ['赤', '黒', '赤'],
    'ac-17': ['水色', '黄', '水色'],
    'ac-18': ['水色', '黄', '水色'],
    'ac-29': ['緑', '白', '緑'],
    'ac-30': ['赤', '白', '緑'],
    'ac-31': ['水色', '黄', '水色'],
    'ac-38-39': ['白', '赤', '白'], /* 確認済み（AC-38 も同じ）2026.10.26 */
    'ac-40': ['赤', '黄', '赤'],
    'ac-42': ['緑', '赤', '黄'], /* 下は黄（確認済み。ノーマル刺繍に金・紫・ブルーグレーは使わない）2026.10.26 */
    'ac-48': ['紺', '赤', '紺'],
    'ac-49': ['紺', '赤', '紺'],
    'ac-33': { top: '水色', bottom: '黄' }, /* 細い線で上下に分かれる形 */
    'ac-2': { variants: { 'S': ['紺', '赤', '紺'], 'M': ['赤', '紺', '赤'] } },
    'st-1': ['赤', '白', '緑'],
    'st-5': ['水色', '黄', '水色'],
    'st-7': ['水色', '黄', '水色'],
    'st-13': ['赤', '白', '緑'],
    'st-6': { variants: { 'S': ['紺', '赤', '紺'], 'M': ['赤', '白', '赤'] } },
    'sb-8': ['黒', '赤', '黄'],
    'sb-9': ['白', '赤', '紺'],
    'sb-14': ['水色', '黄', '水色'],
    'sb-17': ['紺', '黄', '紺'],
    'sb-18': ['赤', '白', '黒'],
    'sb-123': ['赤', '白', '緑'],
    'sb-5': { variants: { 'S': ['白', '緑', '赤'], 'M': ['赤', '白', '紺'], 'L': ['赤', '白', '水色'] } },
    'jb-2': ['赤', '黄', '赤'],
    'jb-27': ['黒', '黄', '赤'], /* 〇は黒（確認済み）2026.10.26 */
    'jb-32': ['赤', '紺', '赤'],
    'jb-35': ['赤', '黄', '赤'],
    'jb-36': ['赤', '黄', '赤'],
    'jb-44': ['赤', '黄', '赤'],
    'jb-46': ['赤', '紺', '赤'],
    'jb-52': ['水色', '白', '水色'],
    'jb-53': ['赤', '白', '黒'],
    'jb-54': ['水色', '白', '黄'],
    'jb-58': ['白', '紺', '赤'],
    'jb-60': ['赤', '黄', '赤'],
    'jb-63': ['紺', '黒', '白'],
    'jb-68': ['水色', '黄', '水色'],
    'jb-70': ['赤', '白', '赤'],
    'jb-71': ['紺', '黄', '紺'],
    'jb-74': ['紺', '黄', '赤'],
    'jb-77': ['赤', '白', '赤'],
    /* ここまで：PDFの表から足した製品 */
    'jb-14': { top: '紺', bottom: '赤' },
    'g-38': { top: '紺', bottom: '赤' },
    'g-52': { top: '紺', bottom: '赤' },
    'g-65': { lr: ['緑', '赤'] },
    'jb-75': { lr: ['緑', '赤'] },
    'jb-10': { lr: ['緑', '赤'] },
    'st-9': { lr: ['緑', '赤'] },
    'ac-1': { leather: true },
    'ac-3': { leather: true },
    'ac-8': { leather: true },
    'st-16': { leather: true },

    /* 横3本（emb-h3）：上から順。PDFの読み取り 2026.10.24 */
    'g-10': { h: ['赤', '白', '水色'] },
    'g-12': { h: ['黒', '赤', '黄'] },
    'g-23': { h: ['赤', '黄', '赤'] },
    'g-32': { h: ['赤', '黄', '赤'] },
    /* 横3本・固定（emb-h3-fixed） */
    'g-8': { h: ['水色', '白', '水色'] },
    'g-9': { h: ['赤', '白', '赤'] },
    /* 縦3本（emb-v3）：左から順 */
    'ac-13': { v: ['緑', '赤', '黄'] },
    'ac-14': { v: ['紺', '黄', '赤'] },
    'jb-18-19': { v: ['緑', '白', '赤'] },
    /* 2本線（emb-v2）：上から順 */
    'g-28': { h: ['紺', '赤'] },
    'g-37': { h: ['赤', '緑'] },
    'st-33': { h: ['黄', '水色'] },
    /* st-3：右が開いた四角（上＝白の横線、左＝紺の縦線、下＝赤の横線）。写真から 2026.10.24 */
    /* サイズ（バリエーション）で変わる製品：選択肢の名前 → 指定。名前は「スリム:￥2,750」の「:」より前 2026.10.24 */
    'g-30-g-14': {
      variants: {
        'スリム': ['水色', '赤', '緑'],      /* g-30 */
        'マチ広め': ['緑', '黄', '水色']     /* g-14（上から緑・黄・水色。本人確認済み） */
      }
    },
    'g-26-26c': {
      variants: {
        'シンプル': ['水色', '黒', '水色'],  /* g-26 */
        'カード有': ['赤', '黒', '赤']       /* g-26-c */
      }
    },
    'sb-10-20': {
      variants: {
        '定番': { h: ['赤', '白', '緑'] },   /* sb-20 */
        '縦長': { h: ['紺', '赤', '緑'] }    /* sb-10 */
      }
    },
    'st-3': { frame: { top: '白', left: '紺', bottom: '赤' } }
  };

  var uid = 0;
  var queued = false;
  var observer = null;
  var attached = false;

  function hex(name) {
    return THREAD_HEX[name] || '#999999';
  }

  function getHandle() {
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';

    var handle = match[1];

    try {
      handle = decodeURIComponent(match[1]);
    } catch (error) {
      handle = match[1];
    }

    /* テスト製品（ハンドルの頭が test-）は、本番と同じ表で引く。全角のハンドル（ｇ-39）も半角にそろえて引く 2026.10.24 */
    return handle.normalize('NFKC').replace(/^test-/, '');
  }

  /* 選択中の革色の名前を読む（選択欄・ラジオの両方を見る）2026.10.24 */
  function getLeatherName() {
    var names = Object.keys(LEATHER_STANDARD);

    function pick(text) {
      var t = String(text || '').trim().replace(/\s+/g, '');
      return names.indexOf(t) !== -1 ? t : '';
    }

    var selects = document.querySelectorAll('select[data-variant-input], select[name*="革色"], select[name*="色"]');

    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      var found = pick(select.value) ||
        (select.selectedIndex >= 0 ? pick(select.options[select.selectedIndex].textContent) : '');
      if (found) return found;
    }

    var radios = document.querySelectorAll('input[type="radio"]:checked');

    for (var k = 0; k < radios.length; k++) {
      var radio = radios[k];
      var found2 = pick(radio.value);

      if (!found2 && radio.id) {
        var label = document.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
        if (label) found2 = pick(label.textContent);
      }

      if (found2) return found2;
    }

    return '';
  }

  /* イカリの形（100×100）：〇は45度の四角、V は直線 2026.10.24 */
  var THIN = 6;
  var THICK = 9.5;

  var SHAPES = {
    ring: { w: THIN, d: '<path d="M50 16 L62 28 L50 40 L38 28 Z" fill="none" stroke-linejoin="round"/>' },
    bar: { w: THIN, d: '<path d="M23 46 H77" stroke-linecap="round" fill="none"/>' },
    stem: { w: THICK, d: '<path d="M50 49 V87" fill="none"/>' },
    v: { w: THICK, d: '<path d="M15 66 L50 87 L85 66" stroke-linejoin="round" stroke-linecap="round" fill="none"/>' }
  };

  /* 1パーツを描く。白だけ薄いグレーの縁を下に敷く。clip があれば左右の片側だけ 2026.10.24 */
  function part(shape, colorName, clipId) {
    var s = SHAPES[shape];
    var inner = '';

    if (colorName === '白') {
      inner += '<g stroke="#999999" stroke-width="' + (s.w + 4) + '">' + s.d + '</g>';
    }

    inner += '<g stroke="' + hex(colorName) + '" stroke-width="' + s.w + '">' + s.d + '</g>';

    return clipId ? '<g clip-path="url(#' + clipId + ')">' + inner + '</g>' : inner;
  }

  /* colors：{ ring, bar, stem, v } 各値は色名、または { L, R } 2026.10.24 */
  function anchorSvg(colors) {
    uid += 1;
    var id = 'jpa' + uid;
    var body = '';

    ['ring', 'bar', 'stem', 'v'].forEach(function (key) {
      var c = colors[key];

      if (typeof c === 'string') {
        body += part(key, c);
      } else {
        body += part(key, c.L, id + 'L') + part(key, c.R, id + 'R');
      }
    });

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false">' +
      '<defs><clipPath id="' + id + 'L"><rect x="0" y="0" width="50" height="100"/></clipPath>' +
      '<clipPath id="' + id + 'R"><rect x="50" y="0" width="50" height="100"/></clipPath></defs>' +
      body + '</svg>';
  }

  /* 線のSVG：dir が 'h' なら横線を上から順に、'v' なら縦線を左から順に。枠は白だけ薄いグレー 2026.10.24 */
  function linesSvg(dir, colors) {
    var n = colors.length;
    var body = '';

    colors.forEach(function (colorName, i) {
      var edge = colorName === '白' ? ' stroke="#999999" stroke-width="3"' : '';
      var pos = n === 3 ? [16, 42, 68][i] : [29, 55][i];
      var rect = dir === 'v'
        ? '<rect x="' + pos + '" y="12" width="16" height="76" rx="8"'
        : '<rect x="5" y="' + pos + '" width="90" height="16" rx="8"';

      body += rect + ' fill="' + hex(colorName) + '"' + edge + '/>';
    });

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false">' + body + '</svg>';
  }

  /* 右が開いた四角のSVG：上と下が横線、左が縦線。線同士は隣り合い、重ならない 2026.10.24 */
  function frameSvg(f) {
    function edge(colorName) {
      return colorName === '白' ? ' stroke="#999999" stroke-width="3"' : '';
    }

    function bar(x, y, w, h, colorName) {
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="7" fill="' +
        hex(colorName) + '"' + edge(colorName) + '/>';
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false">' +
      bar(16, 16, 68, 14, f.top) + bar(16, 70, 68, 14, f.bottom) + bar(16, 32, 14, 36, f.left) + '</svg>';
  }

  /* 選択中のバリエーション名を読む。選択肢は「スリム:￥2,750」の形なので「:」より前だけ使う 2026.10.24 */
  function getVariantName() {
    var selects = document.querySelectorAll('select[data-variant-input]');

    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.selectedIndex < 0) continue;

      var text = select.options[select.selectedIndex].textContent.trim();
      var match = text.match(/^([^:：]+)[:：]/);
      return match ? match[1].trim() : text;
    }

    return '';
  }

  /* 標準の行の名前：色名を詰めて短くする。水色は「水」と書く。文字の先頭は「しない：」（2026.10.25に「色名：変更無し」から変更）2026.10.24 */
  function shortName(color) {
    return color === '水色' ? '水' : color;
  }

  /* 表の指定から、絵と文字を作る。作れない時は null（何もしない）2026.10.24 */
  function build(spec) {
    if (!spec) return null;

    /* バリエーションで変わる製品：選択中の名前で指定を選び直す */
    if (spec.variants) {
      return build(spec.variants[getVariantName()]);
    }

    if (spec instanceof Array) {
      return {
        svg: anchorSvg({ ring: spec[0], bar: spec[1], stem: spec[1], v: spec[2] }),
        label: 'しない：' + spec.map(shortName).join('')
      };
    }

    if (spec.frame) {
      return {
        svg: frameSvg(spec.frame),
        label: 'しない：' + shortName(spec.frame.top) + shortName(spec.frame.left) + shortName(spec.frame.bottom) /* 位置語（上・左・下）を消した。位置は画像で示す 2026.10.26 */
      };
    }

    if (spec.h || spec.v) {
      var list = spec.h || spec.v;

      return {
        svg: linesSvg(spec.h ? 'h' : 'v', list),
        label: 'しない：' + list.map(shortName).join('')
      };
    }

    if (spec.top) {
      return {
        svg: anchorSvg({ ring: spec.top, bar: spec.top, stem: spec.bottom, v: spec.bottom }),
        label: 'しない：' + shortName(spec.top) + shortName(spec.bottom) /* 位置語（上・下）を消した 2026.10.26 */
      };
    }

    if (spec.lr) {
      var lr = { L: spec.lr[0], R: spec.lr[1] };

      return {
        svg: anchorSvg({ ring: lr, bar: lr, stem: lr, v: lr }),
        label: 'しない：' + shortName(spec.lr[0]) + shortName(spec.lr[1]) /* 位置語（左・右）を消した 2026.10.26 */
      };
    }

    if (spec.leather) {
      var color = LEATHER_STANDARD[getLeatherName()];
      if (!color) return null;

      return {
        svg: anchorSvg({ ring: color, bar: color, stem: color, v: color }),
        label: 'しない：' + shortName(color)
      };
    }

    return null;
  }

  /* 色見本の枠：書き換えは「内容が変わった時だけ」行う（点滅・無限ループ防止）。
     ※絵は毎回IDが変わるので、比較は「種類＋文字」で行う 2026.10.24 */
  function setChip(chip, built, size) {
    if (!chip) return;

    var key = size + '|' + built.label;

    if (chip.dataset.japlishAnchor !== key) {
      chip.innerHTML = built.svg;
      chip.dataset.japlishAnchor = key;
    }

    chip.style.setProperty('display', 'inline-flex', 'important');
    chip.style.setProperty('align-items', 'center', 'important');
    chip.style.setProperty('justify-content', 'center', 'important');
    chip.style.setProperty('width', size + 'px', 'important');
    chip.style.setProperty('height', size + 'px', 'important');
    chip.style.setProperty('min-width', size + 'px', 'important');
    chip.style.setProperty('flex', '0 0 ' + size + 'px', 'important');
    chip.style.setProperty('background-color', 'transparent', 'important');
    chip.style.setProperty('background-image', 'none', 'important');
    chip.style.setProperty('border', '0', 'important');
    chip.style.setProperty('border-radius', '0', 'important');
    chip.style.setProperty('overflow', 'visible', 'important');
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function setAttr(element, name, value) {
    if (element && element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  }

  function updateField(field) {
    var built = build(STANDARD[getHandle()]);
    if (!built) return;

    var option = field.querySelector('.spb-imagedropdown-option[data-value="変更しない"], .spb-imagedropdown-option[data-value="しない"]');

    if (option) {
      setChip(option.querySelector('.spb-imagedropdown-chip'), built, 34);
      window.japlishAfterImage.place(option.querySelector('.spb-imagedropdown-chip'), option.querySelector('.spb-imagedropdown-optionlabel'), built.label, 34); /* しない：色名［画像］ 2026.10.25 */
      setAttr(option, 'aria-label', built.label);
    }

    var selectedOption = field.querySelector('.spb-imagedropdown-option[aria-selected="true"]');
    var selected = field.querySelector('.spb-imagedropdown-selected');

    if (!selected) return;

    var isNoChange = !selectedOption ||
      /^(変更)?しない$/.test(selectedOption.getAttribute('data-value') || '');

    if (isNoChange) {
      setChip(selected.querySelector('.spb-imagedropdown-chip'), built, 28);
      window.japlishAfterImage.place(selected.querySelector('.spb-imagedropdown-chip'), selected.querySelector('.spb-imagedropdown-selected-label'), built.label, 28); /* しない：色名［画像］ 2026.10.25 */
    } else {
      window.japlishAfterImage.restore(selected.querySelector('.spb-imagedropdown-chip'), selected.querySelector('.spb-imagedropdown-selected-label')); /* しない以外は元の並び 2026.10.25 */
    }
  }

  function findFields() {
    var fields = [];

    document.querySelectorAll('#infiniteoptions-container label').forEach(function (label) {
      if (label.textContent.trim() !== FIELD_LABEL) return;

      var field = label.closest('[class*="spb-io-field-"]');

      if (field && fields.indexOf(field) === -1) {
        fields.push(field);
      }
    });

    return fields;
  }

  function updateAll() {
    findFields().forEach(updateField);
  }

  function scheduleUpdate() {
    if (queued) return;
    queued = true;

    window.setTimeout(function () {
      queued = false;
      updateAll();
    }, 60);
  }

  function attach() {
    if (attached) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    observer = new MutationObserver(scheduleUpdate);

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });

    attached = true;
    updateAll();
    return true;
  }

  /* ===== ツートンの見本（twotone-ito.js）へ刺繍の絵を渡す 2026.10.26 =====
     絵はすべてSVGで描く。アプリの候補欄の画像（実際の糸の写真）は使わない。定番を選んでも、1色ずつ選んでも、同じ描き方になる。
     読む欄（項目名で探す。クラスの horizontal-top は「補強糸の変更」にも付いているので使わない）：
       刺繍の変更：しない／イカリから選ぶ／三本線から選ぶ／アルファベットにする／刺繍を無くす
       イカリの選択：定番（例「赤白水（フランス）」）／自分で配色▼／メモ欄で伝える▼
         自分で配色 → イカリの【上】＝〇、【中】＝横棒＋縦棒、【下】＝V
       横三本線の配色（縦三本線の配色も同じ扱い）：定番／自分で配色▼／メモ欄で伝える▼
         自分で配色 → 横三本【上】【中】【下】（縦三本【左】【中】【右】）
       ABCの色・ABCの選択（クラス abc-color・abc-letter）
     メモ欄で伝える・選びかけで色がそろわない時は、刺繍を描かない */

  /* 色名の拾い方：長い名前から先に見る。「水」は水色 */
  var COLOR_TOKENS = ['ブルーグレー', 'カーキ', '水色', '赤', '白', '緑', '黒', '茶', '金', '黄', '水', '紺', '紫'];

  function parseColors(text) {
    var t = String(text || '').split(/[（(]/)[0].replace(/\s+/g, '');
    var list = [];

    while (t) {
      var hit = '';

      for (var i = 0; i < COLOR_TOKENS.length; i++) {
        if (t.indexOf(COLOR_TOKENS[i]) === 0) {
          hit = COLOR_TOKENS[i];
          break;
        }
      }

      if (!hit) return [];

      list.push(hit === '水' ? '水色' : hit);
      t = t.slice(hit.length);
    }

    return list;
  }

  /* アルファベットの絵：糸の色で太い文字。白だけ薄いグレーの縁 */
  function letterSvg(letter, colorName) {
    var edge = colorName === '白' ? ' stroke="#999999" stroke-width="3" paint-order="stroke"' : '';

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false">' +
      '<text x="50" y="80" text-anchor="middle" font-family="Georgia, \'Times New Roman\', serif" font-weight="700" font-size="84" fill="' +
      hex(colorName) + '"' + edge + '>' + String(letter).slice(0, 1) + '</text></svg>';
  }

  /* 選び方（choice）から絵を作る。choice の形：
     { kind: 'none' } … しない（標準色）
     { kind: 'remove' } … 刺繍を無くす
     { kind: 'anchor', colors: ['上','中','下'] }
     { kind: 'lines', dir: 'h' か 'v', colors: [...] }
     { kind: 'abc', letter: 'A', color: '赤' } */
  function fromChoice(choice, handle) {
    if (!choice || choice.kind === 'none') {
      return build(STANDARD[String(handle || '').normalize('NFKC').replace(/^test-/, '')]);
    }

    if (choice.kind === 'anchor' && choice.colors && choice.colors.length === 3) {
      var c = choice.colors;

      return {
        svg: anchorSvg({ ring: c[0], bar: c[1], stem: c[1], v: c[2] }),
        label: 'anchor:' + c.join('')
      };
    }

    if (choice.kind === 'lines' && choice.colors && choice.colors.length >= 2) {
      return {
        svg: linesSvg(choice.dir === 'v' ? 'v' : 'h', choice.colors),
        label: 'lines:' + choice.dir + choice.colors.join('')
      };
    }

    if (choice.kind === 'abc' && choice.letter && choice.color) {
      return {
        svg: letterSvg(choice.letter, choice.color),
        label: 'abc:' + choice.letter + choice.color
      };
    }

    return null;
  }

  /* 画面に出ている欄を、項目名（完全一致または前方一致）で探す */
  function visibleFields(test) {
    var found = [];

    document.querySelectorAll('#infiniteoptions-container label').forEach(function (label) {
      if (!test(label.textContent.trim())) return;

      var field = label.closest('[class*="spb-io-field-"]');

      if (field && field.getClientRects().length && found.indexOf(field) === -1) {
        found.push(field);
      }
    });

    return found;
  }

  function selectedValue(field) {
    if (!field) return '';

    var option = field.querySelector('.spb-imagedropdown-option[aria-selected="true"]');
    if (option) return (option.getAttribute('data-value') || '').trim();

    var select = field.querySelector('select');
    return select ? select.value.trim() : '';
  }

  /* 定番・自分で配色・メモの3通りを読む。parts は「自分で配色」の時の欄（並び順どおり） */
  function readPattern(patternField, parts) {
    var value = selectedValue(patternField);

    if (!value || /メモ/.test(value)) return null;

    if (/自分で配色/.test(value)) {
      var colors = parts.map(function (field) {
        return parseColors(selectedValue(field))[0] || '';
      });

      return colors.every(Boolean) ? colors : null;
    }

    var preset = parseColors(value);
    return preset.length ? preset : null;
  }

  /* 今の画面の選択を、choice にまとめる */
  function readChoice() {
    var field = findFields()[0];
    if (!field) return { kind: 'none' };

    var value = selectedValue(field);

    if (!value || /^(変更)?しない$/.test(value)) return { kind: 'none' };
    if (/無くす/.test(value)) return { kind: 'remove' };

    if (/イカリ/.test(value)) {
      var anchorColors = readPattern(
        visibleFields(function (t) { return t === 'イカリの選択'; })[0],
        visibleFields(function (t) { return /^イカリの【/.test(t); })
      );

      return anchorColors ? { kind: 'anchor', colors: anchorColors } : null;
    }

    if (/三本線/.test(value)) {
      var patternField = visibleFields(function (t) { return /三本線の配色$/.test(t); })[0];
      if (!patternField) return null;

      var dir = /縦/.test(patternField.querySelector('label').textContent) ? 'v' : 'h';
      var lineColors = readPattern(
        patternField,
        visibleFields(function (t) { return dir === 'v' ? /^縦三本【/.test(t) : /^横三本【/.test(t); })
      );

      return lineColors ? { kind: 'lines', dir: dir, colors: lineColors } : null;
    }

    if (/アルファベット/.test(value)) {
      var colorField = document.querySelector('#infiniteoptions-container .abc-color');
      var letterField = document.querySelector('#infiniteoptions-container .abc-letter');
      var abcColor = parseColors(selectedValue(colorField))[0] || '';
      var letter = selectedValue(letterField);

      return abcColor && letter ? { kind: 'abc', letter: letter, color: abcColor } : null;
    }

    return null;
  }

  window.japlishEmb = window.japlishEmb || {};

  /* 標準色だけが欲しい時（プレビューなど） */
  window.japlishEmb.standardFor = function (handle) {
    return fromChoice({ kind: 'none' }, handle);
  };

  /* 選び方を渡して絵を作る（プレビュー用） */
  window.japlishEmb.fromChoice = fromChoice;

  /* 今の画面の選択で描く刺繍。描かない時は null */
  window.japlishEmb.main = function () {
    var choice = readChoice();
    if (!choice || choice.kind === 'remove') return null;

    return fromChoice(choice, getHandle());
  };

  document.addEventListener('change', scheduleUpdate);

  document.addEventListener('click', function (event) {
    if (event.target.closest('#infiniteoptions-container')) {
      scheduleUpdate();
    }
  });

  function start() {
    if (attach()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (attach() || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* 刺繍の変更（イカリ・三本線・二本線）「変更しない」行の色見本ここまで */


/* 左右の補強（emb-left-right）「変更しない」行の色見本ここから */
/* 対象：項目名「補強糸の変更」の画像付きプルダウン。g-39＝横棒（左が緑・右が赤）、sb-1-2＝縦棒2本（左が緑・右が赤）。標準色の表にあるハンドルだけ処理するので、他の補強ブロックには影響しない 2026.10.24 */
(function () {
  'use strict';

  var FIELD_LABEL = '補強糸の変更';

  /* 糸の色（twotone-ito.js の THREAD_HEX と同じ値） 2026.10.24 */
  var THREAD_HEX = {
    '金': '#F5DC38',
    '赤': '#DE0913',
    '白': '#FCF9F2',
    '緑': '#029656',
    '黒': '#2E2D2D',
    'カーキ': '#706939',
    '茶': '#67361D',
    '黄': '#FCF00A',
    '水色': '#38A0FF',
    '紺': '#24408E',
    '紫': '#7F16A6',
    'ブルーグレー': '#718AAB'
  };

  /* 標準色の表：商品ハンドル → 向きと [左, 右]。horizontal＝横棒、vertical＝縦棒 2026.10.24 */
  var STANDARD = {
    'g-39': { dir: 'horizontal', colors: ['緑', '赤'] },
    'sb-1-2': { dir: 'vertical', colors: ['緑', '赤'] }
  };

  /* プレビュー用に表を公開（左右2色：[左, 右]）2026.10.26 */
  window.japlishEmbTables = window.japlishEmbTables || {};
  window.japlishEmbTables.reinLeftRight = STANDARD;

  var queued = false;
  var observer = null;
  var attached = false;

  function getHandle() {
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';

    var handle = match[1];

    try {
      handle = decodeURIComponent(match[1]);
    } catch (error) {
      handle = match[1];
    }

    /* テスト製品（ハンドルの頭が test-）は、本番と同じ表で引く。全角のハンドル（ｇ-39）も半角にそろえて引く 2026.10.24 */
    return handle.normalize('NFKC').replace(/^test-/, '');
  }

  /* 左右の棒のSVG：横棒＝1本の棒を中央で左右に分ける／縦棒＝縦の棒を左右に1本ずつ。枠は白だけ薄いグレー 2026.10.24 */
  function lrSvg(dir, colors) {
    function edge(colorName) {
      return colorName === '白' ? ' stroke="#999999" stroke-width="3"' : '';
    }

    function bar(x, y, w, h, colorName) {
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="8" fill="' +
        (THREAD_HEX[colorName] || '#999999') + '"' + edge(colorName) + '/>';
    }

    var body = dir === 'vertical'
      ? bar(26, 12, 16, 76, colors[0]) + bar(58, 12, 16, 76, colors[1])
      : bar(5, 42, 44, 16, colors[0]) + bar(51, 42, 44, 16, colors[1]);

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" ' +
      'width="100%" height="100%" aria-hidden="true" focusable="false">' + body + '</svg>';
  }

  /* 色見本の枠：書き換えは「内容が変わった時だけ」行う（点滅・無限ループ防止） 2026.10.24 */
  function setChip(chip, svg, size) {
    if (!chip) return;

    var key = size + '|' + svg;

    if (chip.dataset.japlishLR !== key) {
      chip.innerHTML = svg;
      chip.dataset.japlishLR = key;
    }

    chip.style.setProperty('display', 'inline-flex', 'important');
    chip.style.setProperty('align-items', 'center', 'important');
    chip.style.setProperty('justify-content', 'center', 'important');
    chip.style.setProperty('width', size + 'px', 'important');
    chip.style.setProperty('height', size + 'px', 'important');
    chip.style.setProperty('min-width', size + 'px', 'important');
    chip.style.setProperty('flex', '0 0 ' + size + 'px', 'important');
    chip.style.setProperty('background-color', 'transparent', 'important');
    chip.style.setProperty('background-image', 'none', 'important');
    chip.style.setProperty('border', '0', 'important');
    chip.style.setProperty('border-radius', '0', 'important');
    chip.style.setProperty('overflow', 'visible', 'important');
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function setAttr(element, name, value) {
    if (element && element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  }

  /* 標準の行の名前：色名を詰めて短くする。水色は「水」と書く。文字の先頭は「しない：」（2026.10.25に「色名：変更無し」から変更）2026.10.24 */
  function shortName(color) {
    return color === '水色' ? '水' : color;
  }

  function updateField(field) {
    var spec = STANDARD[getHandle()];
    if (!spec) return;

    var svg = lrSvg(spec.dir, spec.colors);
    var label = 'しない：' + shortName(spec.colors[0]) + shortName(spec.colors[1]); /* 位置語（左・右）を消した 2026.10.26 */

    /* 候補欄の「変更しない」行 */
    var option = field.querySelector('.spb-imagedropdown-option[data-value="変更しない"], .spb-imagedropdown-option[data-value="しない"]');

    if (option) {
      setChip(option.querySelector('.spb-imagedropdown-chip'), svg, 34);
      window.japlishAfterImage.place(option.querySelector('.spb-imagedropdown-chip'), option.querySelector('.spb-imagedropdown-optionlabel'), label, 34); /* しない：色名［画像］ 2026.10.25 */
      setAttr(option, 'aria-label', label);
    }

    /* 閉じた選択欄：「変更しない」を選んでいる時だけ置き換える */
    var selectedOption = field.querySelector('.spb-imagedropdown-option[aria-selected="true"]');
    var selected = field.querySelector('.spb-imagedropdown-selected');

    if (!selected) return;

    var isNoChange = !selectedOption ||
      /^(変更)?しない$/.test(selectedOption.getAttribute('data-value') || '');

    if (isNoChange) {
      setChip(selected.querySelector('.spb-imagedropdown-chip'), svg, 28);
      window.japlishAfterImage.place(selected.querySelector('.spb-imagedropdown-chip'), selected.querySelector('.spb-imagedropdown-selected-label'), label, 28); /* しない：色名［画像］ 2026.10.25 */
    } else {
      var otherChip = selected.querySelector('.spb-imagedropdown-chip');
      window.japlishAfterImage.restore(otherChip, selected.querySelector('.spb-imagedropdown-selected-label')); /* しない以外は元の並び 2026.10.25 */

      /* 「補強糸を無くす」などを選んだ時に、こちらで描いた絵を残さない 2026.10.26 */
      if (otherChip && otherChip.dataset.japlishLR) {
        otherChip.innerHTML = '';
        delete otherChip.dataset.japlishLR;

        ['display', 'align-items', 'justify-content', 'width', 'height', 'min-width', 'flex',
          'background-color', 'background-image', 'border', 'border-radius', 'overflow'].forEach(function (name) {
          otherChip.style.removeProperty(name);
        });
      }
    }
  }

  /* 項目名が「補強糸の変更」の項目を探す 2026.10.24 */
  function findFields() {
    var fields = [];

    document.querySelectorAll('#infiniteoptions-container label').forEach(function (label) {
      if (label.textContent.trim() !== FIELD_LABEL) return;

      var field = label.closest('[class*="spb-io-field-"]');

      if (field && fields.indexOf(field) === -1) {
        fields.push(field);
      }
    });

    return fields;
  }

  function updateAll() {
    findFields().forEach(updateField);
  }

  function scheduleUpdate() {
    if (queued) return;
    queued = true;

    window.setTimeout(function () {
      queued = false;
      updateAll();
    }, 60);
  }

  function attach() {
    if (attached) return true;

    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    observer = new MutationObserver(scheduleUpdate);

    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected']
    });

    attached = true;
    updateAll();
    return true;
  }

  document.addEventListener('change', scheduleUpdate);

  document.addEventListener('click', function (event) {
    if (event.target.closest('#infiniteoptions-container')) {
      scheduleUpdate();
    }
  });

  function start() {
    if (attach()) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (attach() || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* 左右の補強（emb-left-right）「変更しない」行の色見本ここまで */


/* 補強・ネームの色と形を返す（プレビュー用）ここから */
/* window.japlishEmb.reinforce()：補強の形と色。「しない」＝標準色、変えた時＝選んだ色、「補強糸を無くす」＝null。
   形：'h'（横線・1色）／'v'（縦線・1色）／'box'（四角・1色）／'left-right'（左右・2色）／'top-bottom'（上下・2色）。2色の色は [左,右] または [上,下] の順
   window.japlishEmb.name()：ネームの種類（bag-15／goods-15／goods-9）。付ける・付けないの読み取りは、欄の並びを確認してから 2026.10.26
   選択が変わったら、document に 'japlish:emb-change' を飛ばす（画面は書き換えない）2026.10.26 */
(function () {
  'use strict';

  var COLOR_NAMES = [
    'ブルーグレー', 'カーキ', '水色', '金', '赤', '白', '緑', '黒', '茶', '黄', '紺', '紫'
  ];

  var HEX = {
    '金': '#F5DC38', '赤': '#DE0913', '白': '#FCF9F2', '緑': '#029656', '黒': '#2E2D2D',
    'カーキ': '#706939', '茶': '#67361D', '黄': '#FCF00A', '水色': '#38A0FF',
    '紺': '#24408E', '紫': '#7F16A6', 'ブルーグレー': '#718AAB'
  };

  var FIELD_LABEL = '補強糸の変更';
  var FOLLOW_THREAD = '@糸と同じ';

  /* タグが渡されていない時のための、ハンドル別の形（1色の10製品）*/
  var SHAPE_BY_HANDLE = {
    'ac-2': 'h', 'g-5': 'h', 'g-13': 'h',
    'ac-13': 'v', 'ac-14': 'v', 'st-3': 'v',
    'g-2': 'box', 'g-21': 'box', 'g-22': 'box', 'g-65': 'box'
  };

  function getHandle() {
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return '';

    var handle = match[1];

    try {
      handle = decodeURIComponent(match[1]);
    } catch (error) {
      handle = match[1];
    }

    return handle.normalize('NFKC').replace(/^test-/, '');
  }

  function hasTag(name) {
    var tags = window.japlishProductTags;
    if (!tags || typeof tags.length !== 'number') return false;

    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === name) return true;
    }

    return false;
  }

  function tables() {
    return window.japlishEmbTables || {};
  }

  function colorIn(text) {
    var t = String(text || '');

    for (var i = 0; i < COLOR_NAMES.length; i++) {
      if (t.indexOf(COLOR_NAMES[i]) !== -1) return COLOR_NAMES[i];
    }

    return '';
  }

  /* 選択中のサイズ名で表を引く（「S:￥3,300」の「:」より前）*/
  function lookup(table) {
    if (!table) return null;

    var selects = document.querySelectorAll('select[data-variant-input]');

    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.selectedIndex < 0) continue;

      var text = select.options[select.selectedIndex].textContent.trim();
      var match = text.match(/^([^:：]+)[:：]/);
      var size = match ? match[1].trim() : text;

      if (table[size]) return table[size];
    }

    return table['*'] || null;
  }

  function visibleFields(test) {
    var found = [];

    document.querySelectorAll('#infiniteoptions-container label').forEach(function (label) {
      if (!test(label.textContent.trim())) return;

      var field = label.closest('[class*="spb-io-field-"]');

      if (field && field.getClientRects().length && found.indexOf(field) === -1) {
        found.push(field);
      }
    });

    return found;
  }

  function selectedValue(field) {
    if (!field) return '';

    var option = field.querySelector('.spb-imagedropdown-option[aria-selected="true"]');
    if (option) return (option.getAttribute('data-value') || '').trim();

    var select = field.querySelector('select');
    return select ? select.value.trim() : '';
  }

  /* 補強の形。タグを先に見て、無ければハンドルの表で決める */
  function shapeOf(handle) {
    if (hasTag('emb-rein-h')) return 'h';
    if (hasTag('emb-rein-v')) return 'v';
    if (hasTag('emb-rein-box')) return 'box';
    if (hasTag('emb-bottom-top-under')) return 'top-bottom';
    if (hasTag('emb-left-right')) return 'left-right';

    if (SHAPE_BY_HANDLE[handle]) return SHAPE_BY_HANDLE[handle];
    if (tables().reinTopBottom && tables().reinTopBottom[handle]) return 'top-bottom';
    if (tables().reinLeftRight && tables().reinLeftRight[handle]) return 'left-right';

    return '';
  }

  /* 「糸と同じ」用：ミシン糸の欄で、今選ばれている色（「しない：白」も読む）*/
  function threadColor() {
    var fields = window.japlishThread ? window.japlishThread.fields() : [];

    for (var i = 0; i < fields.length; i++) {
      var label = fields[i].querySelector('.spb-imagedropdown-selected-label');
      var found = label ? colorIn(label.textContent) : '';
      if (found) return found;
    }

    return '';
  }

  function standardColors(shape, handle) {
    if (shape === 'h' || shape === 'v' || shape === 'box') {
      var one = lookup(tables().rein1 && tables().rein1[handle]);
      if (one === FOLLOW_THREAD) one = threadColor();
      return one ? { colors: [one] } : null;
    }

    if (shape === 'top-bottom') {
      var two = lookup(tables().reinTopBottom && tables().reinTopBottom[handle]);
      return two ? { colors: two.slice(0, 2) } : null;
    }

    if (shape === 'left-right') {
      var lr = tables().reinLeftRight && tables().reinLeftRight[handle];
      return lr ? { colors: lr.colors.slice(0, 2), dir: lr.dir } : null;
    }

    return null;
  }

  function make(shape, colors, dir, changed) {
    return {
      shape: shape,
      dir: dir || '',
      colors: colors,
      hex: colors.map(function (name) { return HEX[name] || '#999999'; }),
      changed: !!changed
    };
  }

  window.japlishEmb = window.japlishEmb || {};

  window.japlishEmb.reinforce = function () {
    var handle = getHandle();
    var shape = shapeOf(handle);
    if (!shape) return null;

    var std = standardColors(shape, handle);
    var field = visibleFields(function (t) { return t === FIELD_LABEL; })[0];
    var value = field ? selectedValue(field) : '';

    /* 補強糸を無くす：何も描かない */
    if (/無くす/.test(value)) return null;

    /* しない（まだ選んでいない時も同じ）：標準色 */
    if (!value || /^(変更)?しない$/.test(value)) {
      return std ? make(shape, std.colors, std.dir, false) : null;
    }

    /* 1色：色の名前を、そのまま選ぶ */
    if (shape === 'h' || shape === 'v' || shape === 'box') {
      var picked = colorIn(value);
      if (picked) return make(shape, [picked], '', true);
      return std ? make(shape, std.colors, '', false) : null;
    }

    /* 2色：「変更する」のあとに出る、左・右（または上・下）の欄を読む */
    var isLR = shape === 'left-right';
    var first = visibleFields(function (t) { return isLR ? /^左/.test(t) : /^上/.test(t); })[0];
    var second = visibleFields(function (t) { return isLR ? /^右/.test(t) : /^下/.test(t); })[0];
    var base = std ? std.colors : ['', ''];

    var c0 = colorIn(selectedValue(first)) || base[0];
    var c1 = colorIn(selectedValue(second)) || base[1];

    if (!c0 || !c1) return null;

    return make(shape, [c0, c1], std ? std.dir : '', true);
  };

  window.japlishEmb.name = function () {
    if (hasTag('name-bag-15')) return { type: 'bag-15' };
    if (hasTag('name-goods-15')) return { type: 'goods-15' };
    if (hasTag('name-goods-9')) return { type: 'goods-9' };
    return null;
  };

  /* 選択が変わったら通知する。前回と同じ中身なら飛ばさない。画面は書き換えない 2026.10.26 */
  var lastSignature = '';
  var timer = null;

  function notify() {
    var main = null;
    var reinforce = null;

    try { main = window.japlishEmb.main ? window.japlishEmb.main() : null; } catch (error) { main = null; }
    try { reinforce = window.japlishEmb.reinforce(); } catch (error2) { reinforce = null; }

    var signature = JSON.stringify([main && main.label, reinforce]);
    if (signature === lastSignature) return;
    lastSignature = signature;

    document.dispatchEvent(new CustomEvent('japlish:emb-change', {
      detail: { main: main, reinforce: reinforce, name: window.japlishEmb.name() }
    }));
  }

  function schedule() {
    if (timer) return;

    timer = window.setTimeout(function () {
      timer = null;
      notify();
    }, 150);
  }

  document.addEventListener('change', schedule);

  document.addEventListener('click', function (event) {
    if (event.target.closest('#infiniteoptions-container, .variant-wrapper')) {
      schedule();
    }
  });

  window.setTimeout(notify, 1200);
})();
/* 補強・ネームの色と形を返す（プレビュー用）ここまで */
